// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminSchoolSubscriptions .table-responsive {
  overflow: visible;
}

.SuperAdminSchoolSubscriptions .react-datepicker-popper {
  z-index: 10000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/School/Subscriptions/SuperAdminSchoolSubscriptions.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".SuperAdminSchoolSubscriptions .table-responsive {\n  overflow: visible;\n}\n\n.SuperAdminSchoolSubscriptions .react-datepicker-popper {\n  z-index: 10000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
